import React, { useState, useEffect } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Sidebar from '../common/sidebar';
import { BaseUrl } from '../common/config';
import { http } from '../helper';
import CommonAlert from '../common/Commonalert';
import ShowAlert from '../common/Showalert';
import Select from 'react-select';

const Accountcodeadd = () => {
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const [errMessage, setErrMessage] = useState('');
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [restrictedCodeSet, setRestrictedCodeSet] = useState(new Set());
  const [inputValue, setInputValue] = useState('');

  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = '/';
  }

  if (JSON.parse(sessionStorage.getItem('authData')) !== '' &&
    !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_foodsolutions')) {
    window.location.href = '/unauthorized';
  }

  // Fetch account code options
  useEffect(() => {
    const fetchCodes = async () => {
    try {
      // Fetch all account codes and already added (restricted) ones
      const [allRes, restrictedRes] = await Promise.all([
        http.get(`${BaseUrl}admin/account`),
        http.get(`${BaseUrl}admin/accountcodelist`)
      ]);

      const allCodes = allRes.data.data || [];
      const restrictedCodes = restrictedRes.data.data || [];

      // Build a Set of restricted account codes
      const restrictedSet = new Set(
        restrictedCodes.map(item => item.accountCode?.toLowerCase())
      );
      setRestrictedCodeSet(restrictedSet);
      // Filter only those not already added
      const availableCodes = allCodes.filter(item => {
        return !restrictedSet.has(item.accountCode?.toLowerCase());
      });

      setAccountCodeOptions(availableCodes);
    } catch (err) {
      console.log(err);
    }
  };

  fetchCodes();
}, []);


  // Redirect on cancel
  const handleCancel = (e) => {
    e.preventDefault();
    window.location.href = '/restrictedaccountcode/accountcode';
  };

  // Form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setInputValue(''); // clear invalid typed value
    if (selectedCodes.length === 0) {
      setErrMessage('Please select at least one code.');
      return;
    }

    const payload = {
      selectedAccountCodes: selectedCodes
    };

    http.post(`${BaseUrl}admin/addaccountcode`, payload)
      .then(res => {
        if (res.data.success) {
          setAlertPopup(true);
          setAlertMessage('Account Code(s) added successfully');
          setTimeout(() => {
          window.location.href = '/restrictedaccountcode/accountcode';
        }, 1500);
        } else {
          setErrorPopup(true);
          setErrorMessage('Failed to add account code(s)');
        }
      }).catch(err => {
        setErrorPopup(true);
        setErrorMessage('Something went wrong while submitting.');
        console.log(err);
      });
  };

  const customNoOptionsMessage = () => {
  const input = inputValue.trim().toLowerCase();
  if (restrictedCodeSet.has(input)) {
    return null; // Do not show any message if it's a restricted code
  }
  if (input.length > 0) {
    return 'No options';
  }
  return null;
  };

  return (
    <>
      {errorPopup && <ShowAlert title='Error' message={errorMessage} />}
      {alertPopup && <CommonAlert title='Success' message={alertMessage} />}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title vi">Add Account Code</h1>
              <div className="right-table-outer-wrap">
                <form 
                  method="post" 
                  className="addform form-container-xs"
                  onSubmit={handleSubmit}
                >
                  <div className='input-field col-1'>
                    <label>Account Code</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      noOptionsMessage={customNoOptionsMessage}
                      value={accountCodeOptions
                        .filter(opt => selectedCodes.includes(opt.accountCode))
                        .map(opt => ({
                          value: opt.accountCode,
                          label: `${opt.accountCode}`
                        }))}
                      onChange={(selectedOptions) => {
                        const codes = selectedOptions.map(item => item.value);

                        // No need to re-check restricted here, handled in input validation
                        setSelectedCodes(codes);
                        setInputValue('');
                        if (codes.length > 0) setErrMessage('');
                      }}
                      onInputChange={(value, { action }) => {
                        // Handle only 'input-change' and 'input-blur'
                        if (action === 'input-change') {
                          setInputValue(value);

                          const pastedCode = value.trim().toLowerCase();

                          if (restrictedCodeSet.has(pastedCode)) {
                            setErrMessage(`Account code "${value}" is already restricted`);

                            setTimeout(() => {
                              setErrMessage('');
                              setInputValue(''); // Clear the pasted input
                            }, 1000);
                          }
                        }
                      }}
                      onBlur={() => {
                        setInputValue('');
                      }}
                      inputValue={inputValue}
                      options={accountCodeOptions.map(opt => ({
                        value: opt.accountCode,
                        label: `${opt.accountCode}`
                      }))}
                      className="form-control"
                      placeholder="Select Account Codes"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: 'relative',
                          zIndex: 2
                        })
                      }}
                    />
                    {errMessage && <div className="error-msg">{errMessage}</div>}
                  </div>

                  <button type="submit"  onMouseDown={(e) => e.preventDefault()}>Submit</button>&nbsp;&nbsp;
                  <button onClick={handleCancel}>Cancel</button>
                </form>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Accountcodeadd;
